import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import styles from './StackedBar.module.css';
import diagramChildArrow from '../../../img/icons/diagram-child-arrow.svg'
import { Row } from 'react-bootstrap';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export default function StackedBar({ data, labels, title, backLabeled, isTotal, sortingOrderByLabels }) {
  const options = {
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: backLabeled && 'Бюджет в млн. руб',
        position: 'left',
        font: { size: 16, weight: 500, family: 'Open Sans' },
      },
      legend: {
        display: false,
      },
      tooltip: { enabled: false },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: false,
        ticks: {
          callback: null,
        },
        suggestedMin: 0,
        suggestedMax: 100
      },
    },
  };

  const getOrder = (label) => data.sortingOrder.findIndex(value => label === value)

  const percentsData = useMemo(() => {
    const sortedDatasets = data.datasets.sort((a, b) => getOrder(b.label) - getOrder(a.label))
    const maxValue = sortedDatasets[sortedDatasets.length - 1].data[0]
    return ({...data, datasets: sortedDatasets.map(dataset => ({...dataset, data: [Math.min(dataset.data[0] / maxValue * 100, 100)]}))})
  }, [data])

  return (
    <div className={isTotal ? styles.totals : ''} style={{ width: '50%' }}>
      <div className={styles.wrapper}>
        <div className={styles.bar}>
          <div className={styles.barWrapper}>
            <Bar options={options} data={percentsData} />
          </div>
        </div>
        <div className={styles.legendwrapper}>
          {data.datasets.map((elem, index) => {
            if (elem.data[0] != null) {
              return (
                <div key={index} className={styles.countwrapper}>
                  <div
                    className={styles.box}
                    style={{
                      backgroundColor: elem.backgroundColor,
                    }}
                  />
                  <span className={styles.text}>{`${(elem.data[0] / 1000000).toFixed(3)}`}</span>
                  {labels && <span key={index} className={styles.label} style={{fontSize: isTotal ? 16 : 12}}>{elem.label}</span> }
                </div>
              );
            }
          })}
        </div>
        <Row className={styles.subtitleWrapper} style={{bottom: isTotal ? 0 : -25}}>
          <div className={styles.subtitle}>{title}</div>
        </Row>

        {/*{labels && (*/}
        {/*  <div className={styles.labels}>*/}
        {/*    {data.datasets.map((elem, index) => (*/}
        {/*      <span key={index} className={styles.label}>*/}
        {/*        {elem.label}*/}
        {/*      </span>*/}
        {/*    ))}*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
    </div>
  );
}
